export default {
  ConvertLinkRecordType: {
    "0": "创建新链路",
    "1": "绑定渠道",
    "2": "解绑渠道",
    "3": "添加链路行为",
    "4": "修改行为配置",
    "5": "删除链路行为",
    "6": "启用链路",
    "7": "禁用链路",
    "8": "修改名称"
  },
  PostBackAction: { //行为枚举
    '20': '添加联系人',
    '25': '开口',
    "30": "48小时删除联系人",
    "26": "开口-腾讯二次回传"
  },
  //请求code枚举
  ResponseCode: {
    SUCCESS: 0,
    SKU_NOT_ON_SALE: 81040006, //"商品未上架"
    SKU_USER_MAX_LIMIT: 81040016, //"超出商品限购数量"
    SKU_USER_SERVICE_PERIOD_LIMIT: 81040017 //"超出商品限购服务期"
  },
  //优惠券枚举
  CouponUnailableReasonConstant: {
    REASON_USED: 1,                 //优惠券已使用
    REASON_NOT_START: 2,            //优惠券未开始
    REASON_EXPIRED: 3,              //优惠券已过期
    REASON_NOT_SUPPORT: 4,          //优惠券不支持该sku
    REASON_LESS_THEN_FULL_AMOUNT: 5 //优惠券未到满减金额
  },
  //支付方式
  PayType: {
    WX: '10-10',
    WXTONGLIAN : '10-20',
    WXLAKALA: '10-30',
    WXLIANLIAN: '10-40',
    ALI: '20-10',
    ZFBLAKALA: '20-30',
    ZFBLIANLIAN: '20-40',
    YINLIAN: '40-20',
    BULKPAY: '50-30',
  },
  PayTypeString: {
    10: "微信原生",
    20: "支付宝",
    30: "银行卡",
    40: "银联支付",
    60: "通联微信支付",
    70: '拉卡拉微信支付'
  },
  //支付登录端
  TradeType: {
    WEB: "WEB",
    JSAPI: "JSAPI"
  },
  LklAccountType: {
    JSAPI: 51, // 微信公众号支付，支付宝服务窗支付，银联JS支付，翼支付JS支付、拉卡拉钱包支付
    NATIVE: 41,// ALIPAY，云闪付支持
    MINI: 71, //微信小程序支付
  },
  OrderStatus: {
    PAID: 1, //已支付
    PAYING: 2, //待支付
    CLOSED: 3, //已关闭
    PASSED: 4, //已开通
    REFUND: 5, //已退款
    FREEZE: 6, //已冻结
  },
  OrderUnFinishedReason: {
    EXIST_UNPAID_ORDER: 1, //存在待支付的订单
    EXIST_UNSIGN_ORDER: 2, //存在待签字的订单
  },
  ProductLevelInfo: {
    10: '一档A',
    12: '一档B',
    13: '一档C',
    15: '二档',
    20: '三档',
    25: '四档',
    30: '优惠券',
    35: 'QMT智投',
    36: "财达智投",
    40: "投教一档",
    41: "投教二档",
    50:"旗舰版",
    51:'大师版'
  },
  SkuStatus: {
    WAIT_SALE: 1, // 待上架
    ON_SALE: 2,  //已上架
    OFF_SALE: 3,  //已下架
    PREHEAT_SALE: 4, //预热时间
  },
}
